<template>
  <div>
    <Top/>
    <div class="cght_htmainbox">
      <div class="cght_htmain cgw1216">
         <!--左侧导航开始-->
        <div class="cght_htmainleft">
          <LeftNav :leftNavi='21'/>
        </div>
        <!--左侧导航完成-->
        <div class="cght_htmainright">
          <div style="width:100%;height:30px;padding-top: 5px;">
            <el-button type="primary" size="mini" round plain @click="Createtask()">添加回款信息</el-button>
            <el-button type="primary" size="mini" round plain @click="Export()" icon="el-icon-download">回款信息导出</el-button>
            <div style="float: right;">
              <i class="el-icon-question" style="font-size:15px;color:#436aa6;" @click="dialogVisible = true"></i>
            </div>
          </div>
          <div class="cght_subpagemaina">
            <!--右边内容区域开始-->
            <el-row style="margin-bottom: 10px">
              <el-col :span="7">
                <el-date-picker
                  v-model="listQuery.addtimeBTTime"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                  @change="search"
                  size="small">
                </el-date-picker>
              </el-col>
              <el-col :span="6">
                <el-input size="small" v-model="listQuery.search" clearable placeholder="请输入回款信息" style="width: 300px;" class="filter-item">
                  <el-button slot="append" @click="search">搜索</el-button>
                </el-input>
              </el-col>
            </el-row>
            <el-row style="position: static;margin-top: 8px;">
              <el-col :span="24" class="task">
                <el-table ref="singleTable" :data="list" border v-loading="qyloading" style="width: 100%">
                  <el-table-column align="center" type="selection" width="50"></el-table-column>
                  <el-table-column align="center" prop="title" label="回款信息"></el-table-column>
                  <el-table-column align="center" prop="collection_amount" label="回款金额"></el-table-column>
                  <el-table-column align="center" prop="payment_date" label="回款日期"></el-table-column>
                  <el-table-column label="操作" align="center" fixed="right" width="160">
                    <template slot-scope="scopes">
                      <el-button size="mini" type="text" @click="handleEdit(scopes.$index, scopes.row)">编辑</el-button>
                      <el-popover
                        :ref="`popover-${scopes.$index}`"
                        placement="top"
                        width="160"
                        trigger="click"
                        style="margin-left: 10px;"
                      >
                        <p>确定删除该信息吗？</p>
                        <div style="text-align: right; margin: 0;">
                          <el-button size="mini" type="text" @click="scopes._self.$refs[`popover-${scopes.$index}`].doClose()">取消</el-button>
                          <el-button type="primary" size="mini" @click="handleDelete(scopes.row,scopes.$index,scopes)">确定</el-button>
                        </div>
                        <el-button slot="reference" size="mini" type="text">删除</el-button>
                      </el-popover>
                      <el-popover
                        placement="right"
                        width="400"
                        trigger="click"
                        style="margin-left: 10px;">
                        <ul>
                          <li v-show="scopes.row.voucher" v-for="(item,index) in scopes.row.voucher" :key="index" style="padding: 8px 15px 8px;">
                            <span>{{ item.name }}</span>
                            <el-button type="primary" plain size="mini" style="float: right;" @click="dowloadFiless(item.response)">预览</el-button>
                          </li>
                        </ul>
                        <el-button v-show="scopes.row.voucher || scopes.row.img" slot="reference" size="mini" type="text">回款凭证</el-button>
                      </el-popover>
                    </template>
                  </el-table-column>
                </el-table>
                <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="getInvoicingMoneyList" :pageSizes="[10, 20, 30, 40, 50]"/>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
    <Bottom/>
    <el-dialog title="回款信息编辑" :visible.sync="dialogFormVisible" :close-on-click-modal="false" width="30%">
      <el-form :model="formData" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-row>
          <el-col :span="24">
            <el-form-item label="回款列表" prop="invoicing_id">
              <el-cascader v-model="formData.invoicing_id" :options="InvoicingList" clearable filterable :props="{ value: 'id',label: 'name' }" style="width: 100%;" @change="handleChange"></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="回款金额" prop="collection_amount">
              <el-input-number v-model="formData.collection_amount" size="small" :precision="2" :min="0" :step="1" ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="回款日期" prop="payment_date">
              <el-date-picker type="date" placeholder="请选择回款日期" v-model="formData.payment_date" value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="回款凭证">
              <el-upload
                ref="upload"
                class="upload-demo"
                :action="upload_url"
                :on-success="handlesuccess"
                :on-remove="removeUpload"
                :before-upload="beforeAvatarUpload"
                accept=".xls,.xlsx,.docx,.doc,.jpg,.png,.pdf"
                :file-list="fileList"
                :headers="requestHeaders"
                :auto-upload="true"
                :multiple="true"
              >
                <el-button slot="trigger" size="small" type="primary">上传凭证</el-button>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveInvoicingMoney()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="回款列表说明" :visible.sync="dialogVisible" width="50%">
      <el-carousel :autoplay="false" arrow="always" indicator-position="none" height="700px">
        <el-carousel-item v-for="(item,index) in srcList" :key="index">
          <el-image
            style="width: 100%;"
            :src="item"
            :preview-src-list="srcList">
          </el-image>
        </el-carousel-item>
      </el-carousel>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Top from '@/components/Member/Top'
import LeftNav from '@/components/Member/Left_nav'
import Bottom from '@/components/Member/Bottom'
import Pagination from '@/components/Pagination'
import { mapGetters } from 'vuex'
import api from '@/api/invoicingMoney'
import { getToken } from '@/utils/auth'
import apiConfig from '../../../config/api.config.js'

export default {
  name: 'InvoicingMoney',
  components: { Top, LeftNav, Bottom, Pagination },
  data () {
    return {
      api,
      list: [],
      total: 0,
      upload_url: apiConfig.baseUrl + '/admin/Upload/Upload_invoicing',
      requestHeaders: {
        'X-Token': getToken()
      },
      qyloading: false,
      fileList: [],
      listQuery: {
        limit: 10,
        order: 'payment_date',
        page: 1,
        sort: 'DESC'
      },
      dialogFormVisible: false,
      dialogOrderVisible: false,
      locktype: false,
      formData: {
        id: null,
        invoicing_id: '',
        collection_amount: '',
        payment_date: '',
        is_delete: 1
      },
      rules: {
        invoicing_id: [{ required: true, message: '请选择回款信息', trigger: 'blur' }],
        collection_amount: [{ required: true, message: '请输入回款金额', trigger: 'blur' }],
        payment_date: [{ required: true, message: '请选择回款日期', trigger: 'blur' }]
      },
      visible: false,
      dialogVisible: false,
      srcList: [
        'https://serv.nmzp.com/uploads/1/image/20240422/6687fd0195ca2376df44e5d3201a79b3.png',
        'https://serv.nmzp.com/uploads/1/image/20240422/edd1ff9871497b4d7cf9514d4211d323.png'
      ],
      primary_key: 'id',
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      InvoicingList: []
    }
  },
  computed: {
    ...mapGetters([
      'current_user'
    ])
  },
  mounted () {
    this.getInvoicingList()
    this.getInvoicingMoneyList()
  },
  methods: {
    getInvoicingList () {
      api.getInvoicingList().then(response => {
        this.InvoicingList = response.data
      })
    },
    getInvoicingMoneyList () {
      this.qyloading = true
      if (this.current_user.id === 2 || this.current_user.id === 100) {
        // this.$delete(this.listQuery, 'user_id')
      } else {
        this.listQuery.user_id = this.current_user.id
      }
      api.getInvoicingMoneyList(this.listQuery).then(response => {
        this.list = response.data.items
        this.total = response.data.total
        this.qyloading = false
      })
    },
    Createtask () {
      this.dialogFormVisible = true
      this.formData = {
        id: null,
        invoicing_id: '',
        collection_amount: '',
        payment_date: '',
        is_delete: 1
      }
      this.fileList = []
    },
    handleEdit (index, row) {
      this.dialogFormVisible = true
      this.formData = Object.assign({}, row)
      if (row.voucher) {
        this.fileList = row.voucher
      } else {
        this.fileList = []
      }
    },
    handleDelete (row, index, scopes) {
      api.handleDelete({ id: row.id }).then(response => {
        this.getInvoicingMoneyList()
        scopes._self.$refs[`popover-${scopes.$index}`].doClose()
      })
    },
    saveInvoicingMoney () {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          if (this.locktype) {
            // return false
          }
          this.locktype = true
          this.formData.voucher = this.fileList
          api.saveInvoicingMoney(this.formData).then(response => {
            this.dialogFormVisible = false
            this.locktype = false
            this.getInvoicingMoneyList()
            this.$notify({
              title: '成功',
              message: response.message,
              type: 'success'
            })
          })
        }
      })
    },
    search () {
      this.listQuery.page = 1
      this.getInvoicingMoneyList()
    },
    handleChange (value) {
      this.formData.invoicing_id = value[0]
    },
    // 批量导出
    Export () {
      if (this.$refs.singleTable.selection.length > 0) {
        var ids = this.$refs.singleTable.selection.map(a => a[this.primary_key])
        api.export({id: ids}).then(response => {
          if (response.code === 20000) {
            window.open(response.savename)
          } else if (response.code === 30000) {
            this.$message.error(response.message)
          } else {
            this.$message.error('导出错误')
          }
        })
      } else {
        this.$message({ message: '请选择要导出的数据', type: 'error' })
      }
    },
    handlesuccess (response, file, fileList) {
      if (response.code === 20000) {
        this.fileList = fileList
      } else {
        this.$message.error(response.message)
      }
    },
    beforeAvatarUpload (file) {
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = testmsg === 'xls'
      const extension2 = testmsg === 'xlsx'
      const extension3 = testmsg === 'docx'
      const extension4 = testmsg === 'doc'
      const extension5 = testmsg === 'jpg'
      const extension6 = testmsg === 'pdf'
      const extension7 = testmsg === 'png'
      const extension8 = testmsg === 'zip'
      const extension9 = testmsg === 'rar'
      const isLt2M = file.size / 1024 / 1024 < 10
      if (!extension && !extension2 && !extension3 && !extension4 && !extension5 && !extension6 && !extension7 && !extension8 && !extension9) {
        this.$message({
          message: '上传文件只能是 xls、xlsx、docx、doc、jpg、png、pdf、zip、rar格式!',
          type: 'warning'
        })
      }
      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 10MB!',
          type: 'warning'
        })
      }
      return (extension || extension2 || extension3 || extension4 || extension5 || extension6 || extension7 || !extension8 || !extension9) && isLt2M
    },
    removeUpload (file, fileList) {
      this.fileList = fileList
    },
    dowloadFiless (urlFile) {
      window.open(urlFile.message, '_blank')
    }
  }
}
</script>
<style scoped>
.cght_subpagemaina{
  padding-top: 25px;
}
.cgw1216{
  width: 1445px;
}
.cght_htmainright{
  width: 86%;
}
.ant-card-head {
  min-height: 48px;
  margin-bottom: 40px;
  padding: 0 24px;
  color: rgba(0, 0, 0, .85);
  font-weight: 500;
  font-size: 16px;
  background: 0 0;
  border-bottom: 1px solid #f0f0f0;
  border-radius: 2px 2px 0 0;
  background: #f8faff;
}
.ant-card-head-title {
  color: #1890ff;
  padding-top: 10px;
  float: left;
}
.ant-card-head-button {
  width: 90%;
  padding-top: 5px;
  float: left;
}
.filter-container {
  text-align: right;
  display: inline-block;
  float: right;
}
.highlight{
  background-color: #f0f0f0;
}
.el-popper{
  width:600px !important;
}
.ant-card-bottom{
  border-bottom: 2px solid #f0f0f0;
}
</style>



// WEBPACK FOOTER //
// src/view/member/invoicing_money.vue